import useInitializeData from '@/hooks/useInitializeProject';
import ArtiestFilters from '../desktop/components/ArtiestFilters';
import MobileStyleFilterArtistDetail from '../mobile/MobileStyleFilterArtistDetail';
import { useParams } from 'react-router-dom';
import { getStyleFilterArtistDetailByName } from '@/service/filter';
import { kebabToTitleCase } from '@/utils';
import { useRequest } from 'ahooks';
import { useModel } from '@/pages/Home/Generator/model';
import { FormProvider } from 'react-hook-form';

export default function StyleFilterArtistDetail() {
  const { isMobileOrPad } = useInitializeData();

  const { form } = useModel();

  const { artistName } = useParams<{ artistName: string }>();

  const { data } = useRequest(() => getStyleFilterArtistDetailByName(kebabToTitleCase(artistName ?? '')));

  if (isMobileOrPad) {
    return (
      <FormProvider {...form}>
        <MobileStyleFilterArtistDetail data={data?.data} />
      </FormProvider>
    );
  }
  return (
    <FormProvider {...form}>
      <ArtiestFilters data={data?.data} />;
    </FormProvider>
  );
}
